export default "__VITE_ASSET__Boj86zmz__"